import { i as y, x as p } from "./chunk-lit-element-CNHURX5C.js";
let c = [];
const w = [
  "fonts.googleapis.com",
  "accelerated-checkout-backwards-compat.css"
], R = [], m = (s, e) => e.length === 0 ? s : s.filter((o) => {
  if (o.ownerNode && o.ownerNode instanceof Element) {
    const r = o.ownerNode.id;
    return e.some((t) => r === t);
  }
  return !0;
});
function b() {
  return c.length === 0 && (c = m(
    Array.from(document.styleSheets),
    R
  ).map((s) => {
    if (s.href && w.some((o) => {
      var r;
      return (r = s.href) == null ? void 0 : r.includes(o);
    }))
      return;
    const e = new CSSStyleSheet();
    try {
      const o = Array.from(s.cssRules).map((r) => r.cssText).join(" ");
      return e.replaceSync(o), e;
    } catch (o) {
      console.warn("Failed to parse CSS rules from stylesheet", s), console.warn(o);
    }
  }).filter(Boolean)), c;
}
function f(s) {
  var e;
  return !!(s.cssRules[0].cssText.includes("marquee") || (e = s.cssRules[1]) != null && e.cssText.includes("marquee"));
}
function C(s) {
  return f(s);
}
function S(s) {
  return !f(s);
}
function T() {
  const s = [];
  if (c.length === 0)
    return s;
  const e = Array.from(document.styleSheets).filter(
    C
  );
  return e.length > 0 && e.forEach((o) => {
    const r = new CSSStyleSheet(), t = Array.from(o.cssRules).map((n) => n.cssText).join(" ");
    r.replaceSync(t), s.push(r);
  }), s;
}
class N extends y {
  constructor() {
    super(), this._hasAdoptedGlobalStyleSheets = !1, this.removeAttribute("cloak");
  }
  $queryChildren(e, o = "*", r = !1, t = []) {
    var d, a, u;
    const n = e ?? this, i = () => (t = t.filter((l) => l).filter((l, h) => t.indexOf(l) === h), r && t.length >= r ? (t = t.slice(0, r), !0) : !1);
    if (n.matches(o) && t.push(n), n.shadowRoot && (t = [
      ...t,
      ...((a = (d = n.shadowRoot) == null ? void 0 : d.querySelectorAll) == null ? void 0 : a.call(d, o)) ?? []
    ]), i()) return t;
    if (n.tagName === "SLOT") {
      const l = n.assignedNodes().filter((h) => h.nodeType === 1);
      if (l.length > 0)
        for (const h of l)
          t = [
            ...t,
            ...this.$queryChildren(h, o, r, t)
          ];
    }
    if (i()) return t;
    for (const l of [
      ...((u = n.renderRoot) == null ? void 0 : u.children) ?? [],
      ...n.children ?? []
    ])
      t = this.$queryChildren(l, o, r, t);
    return i(), t;
  }
  $querySelector(e) {
    return this.$queryChildren(this, e, 1)[0];
  }
  $querySelectorAll(e) {
    return this.$queryChildren(this, e);
  }
  updateStyleSheets() {
    if (this.shadowRoot) {
      const e = T();
      this.shadowRoot.adoptedStyleSheets = [
        ...this.shadowRoot.adoptedStyleSheets.filter(S),
        ...e
      ], c = [
        ...this.shadowRoot.adoptedStyleSheets.filter(S),
        ...e
      ];
    }
  }
  connectedCallback() {
    if (super.connectedCallback(), this.shadowRoot && !this._hasAdoptedGlobalStyleSheets) {
      const e = b();
      this.shadowRoot.adoptedStyleSheets = [
        ...e,
        ...this.shadowRoot.adoptedStyleSheets ?? []
      ], this._hasAdoptedGlobalStyleSheets = !0;
    }
  }
  $emit(e, o) {
    return this.dispatchEvent(
      new CustomEvent(e, {
        bubbles: !0,
        composed: !0,
        detail: o
      })
    );
  }
  $listen(e, o) {
    var r;
    (r = this.shadowRoot) == null || r.addEventListener(
      e,
      o.bind(this)
    );
  }
  $hide() {
    this.style.display = "none";
  }
  $show() {
    this.style.display = "";
  }
  render() {
    return p`<slot></slot>`;
  }
}
class $ extends N {
  createRenderRoot() {
    return this;
  }
}
export {
  N as B,
  $ as a
};
